import { render, staticRenderFns } from "./EventSlide.vue?vue&type=template&id=1e2c7b03&scoped=true&"
import script from "./EventSlide.vue?vue&type=script&lang=js&"
export * from "./EventSlide.vue?vue&type=script&lang=js&"
import style0 from "./EventSlide.vue?vue&type=style&index=0&id=1e2c7b03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2c7b03",
  null
  
)

export default component.exports